'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.focussablePropTypes = exports.hasOptionsPropTypes = exports.formControlPropTypes = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.generateId = generateId;
exports.updateValue = updateValue;
exports.handleAddInnerForm = handleAddInnerForm;
exports.handleChangeInnerForm = handleChangeInnerForm;
exports.handleDeleteInnerForm = handleDeleteInnerForm;
exports.getProperty = getProperty;
exports.ApplyPropTypesAndDefaults = ApplyPropTypesAndDefaults;
exports.OutsideEventListener = OutsideEventListener;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactDom = require('react-dom');

var _reactDom2 = _interopRequireDefault(_reactDom);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

var formControlPropTypes = exports.formControlPropTypes = {
    disabled: _propTypes2.default.bool,
    errors: _propTypes2.default.arrayOf(_propTypes2.default.node),
    help: _propTypes2.default.node,
    innerRef: _propTypes2.default.func,
    label: _propTypes2.default.node,
    name: _propTypes2.default.string.isRequired,
    subHelp: _propTypes2.default.node,
    updateValue: _propTypes2.default.func.isRequired,
    value: _propTypes2.default.any
};

var hasOptionsPropTypes = exports.hasOptionsPropTypes = {
    options: _propTypes2.default.arrayOf(_propTypes2.default.shape({
        value: _propTypes2.default.any.isRequired,
        label: _propTypes2.default.string.isRequired,
        richLabel: _propTypes2.default.node
    })).isRequired
};

var focussablePropTypes = exports.focussablePropTypes = {
    handleBlur: _propTypes2.default.func,
    handleFocus: _propTypes2.default.func
};

function generateId(name) {
    return 'id-' + name + '-' + Math.floor(Math.random() * 1e4);
}

/**
 * Mixin-style method to handle any data change in a form.
 *
 * @param {object} data - The data to store in the state.
 *
 * @return {void}
 *
 * It is worth noting that this a mixin style method, hence uses `this`. As such, another important
 * 'parameter' that this method uses is `this.state.data.{itemsKey}` - this contains an array of
 * the inner forms, each of which is an object.
 */
function updateValue(data) {
    // Generate new data by taking a copy of the current state data and overriding keys defined in
    // incoming data.
    this.setState({
        data: _extends({}, this.state.data, data)
    });
}

/**
 * Mixin-style method to handle addition of an item in a nested form.
 *
 * @param {string} itemsKey - The key of the field on *this* form, located in `this.state.data` to
 *                            find the inner forms.
 * @param {object} defaultData - The default data with which to populate the form.
 *
 * @return {void}
 *
 * It is worth noting that this a mixin style method, hence uses `this`. As such, another important
 * 'parameter' that this method uses is `this.state.data.{itemsKey}` - this contains an array of
 * the inner forms, each of which is an object.
 */
function handleAddInnerForm(itemsKey, defaultData) {
    // Get a copy of the item list.
    var itemList = [].concat(_toConsumableArray(this.state.data[itemsKey]));

    // Change the state of the component to insert the new form data.
    if (itemList) {
        itemList.push(defaultData);
    } else {
        itemList = [defaultData];
    }

    // Pass the state data as the new nested form data to be updated by the parent component.
    this.props.updateValue(_defineProperty({}, itemsKey, itemList));
}

/**
 * Mixin-style method to handle changes to a nested form.
 *
 * @param {string} itemsKey - The key of the field on *this* form, located in `this.state.data` to find the inner
 *     forms.
 * @param {number} index - The (numeric) id of the inner form to work on.
 * @param {object} data - The data that changed on that form.
 * @param {object} errors - Any errors occurring.
 *
 * @return {void}
 *
 * It is worth noting that this a mixin style method, hence uses `this`. As such, another important
 * 'parameter' that this method uses is `this.state.data.{itemsKey}` - this contains an array of
 * the inner forms, each of which is an object.
 */
function handleChangeInnerForm(itemsKey, index, data, errors) {
    // Create a new list of items with submitted item
    var itemList = [];

    if (this.state.data[itemsKey] && data) {
        var _iteratorNormalCompletion = true;
        var _didIteratorError = false;
        var _iteratorError = undefined;

        try {
            for (var _iterator = this.state.data[itemsKey][Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                var item = _step.value;

                if (index === item.index) {
                    itemList.push(data);
                } else {
                    itemList.push(item);
                }
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally {
            try {
                if (!_iteratorNormalCompletion && _iterator.return) {
                    _iterator.return();
                }
            } finally {
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
    }

    // Pass the state data as the new nested form data to be updated by the parent component
    this.props.updateValue(_defineProperty({}, itemsKey, itemList));
}

/**
 * Handle deletion of an item from a nested form.
 *
 * @param {string} itemsKey - The key of the field on *this* form, located in `this.state.data` to
 *                            find the inner forms.
 * @param {number} index - The index of the inner form to delete.
 *
 * @return {void} Nothing
 *
 * It is worth noting that this a mixin style method, hence uses `this`. As such, another important
 * 'parameter' that this method uses is `this.state.data.{itemsKey}` - this contains an array of
 * the inner forms, each of which is an object.
 */
function handleDeleteInnerForm(itemsKey, index) {
    // Go through each inner form field and 'filter out' any items that have the same index as the
    // one to be deleted.
    var itemList = this.state.data[itemsKey].filter(function (item) {
        return item.index !== index;
    });

    // Pass the state data as the new nested form data to be updated by the parent component.
    this.props.updateValue(_defineProperty({}, itemsKey, itemList));
}

/**
 * Get a property from an object, optionally following a path and also providing a default.
 *
 * The `key` parameter can take a dot-separated path to a deeply-nested key.
 *
 * `null` values are considered 'empty' for the purposes of this function, and the value of
 * `defaultValue` will be returned in the case that `null` is found. Of course, the default default
 * is `null` anyway, so there you go. This is only true of `null`: `0`, `''` and `false` are all
 * considered to be 'filled' values and will be returned as-is.
 *
 * Example calling:
 *
 *     let obj = { defined: 'string', empty: null }
 *
 *     getProperty(obj, 'defined') => 'string'
 *     getProperty(obj, 'undefined') => null
 *
 *     getProperty(obj, 'defined', 'default') => 'string'
 *     getProperty(obj, 'undefined', 'default') => 'default'
 *
 *     // while `empty` is defined, it is set to null so is considered 'empty'
 *     getProperty(obj, 'empty') => null // null here being the default return, not the value stored
 *     getProperty(obj, 'empty', 'default') => 'default'
 *
 * @param {Object} object The object to find the key on.
 * @param {string} key The key to search for on the object.
 * @param {mixed} defaultValue The value to return if the key isn't found.
 * @returns {mixed} The value of object.key or defaultValue depending on the rules above.
 */
function getProperty(object, key) {
    var defaultValue = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

    if (!object) {
        return defaultValue;
    }

    // if no key, we just care about the object itself
    if (!key) {
        return object;
    }

    // are we using complex path components (i.e. dot-notation)?
    if (key.indexOf('.') !== -1) {
        // take the first 'path component' from the key
        var path = key.split('.');
        var currentKey = path.shift();

        // now getting the value of the object[first-path-part] to kick off recusion
        var currentValue = getProperty(object, currentKey, defaultValue);

        // rebuild the key leaving out the first part we already used
        var restOfKey = path.join('.');

        // now recurse by getting the value of [rest-of-key] from our
        // [first-path-part] value
        return getProperty(currentValue, restOfKey, defaultValue);
    }

    // now the actual reason for this funciton - does the key exist on object and is it 'filled'?
    if (object.hasOwnProperty(key) && object[key] !== null) {
        return object[key];
    }

    return defaultValue;
}

/**
 * Generate a wrapped component where required props can be resolved to a default when null.
 *
 * Take a component, some propType declarations and a map of default props and create a wrapping HOC
 * that will accept the proptypes with nulls and provide the prop's value from the default mapping
 * if null is passed.
 *
 * React, by default, does not use defaultProps when `null` to be pased to a component. But setting
 * the prop to isRequired means that null cannot be passed at all. As such, it sometimes makes sense
 * to be able to have default values when null is passed. That's what this function does.
 *
 * @param {Component} Component - The component to wrap. This component should ahve no propType
 *                                declaration (as it will be overwritten).
 * @param {Object} propTypes - The proptypes for the component (with no `isRequired` attributes
 *                             where you want nullable defalts).
 * @param {Object} defaults - The default values to use for the props that are passed as null.
 *
 * @returns {Function} - The thin wrapping HOC that wraps the main component and applies the
 *                       defaults.
 */
function ApplyPropTypesAndDefaults(Component, propTypes, defaults) {
    // First, make the passed proptypes required where a key exists in defaults and set the strict
    // propTypes on the passed component.
    var strictPropTypes = _extends({}, propTypes);

    for (var prop in defaults) {
        strictPropTypes[prop] = strictPropTypes[prop].isRequired;
    }

    Component.propTypes = strictPropTypes;

    // Now create the wrapping component that inspects the pased props, and fills in the defaults
    // where null is passed.
    var Wrapper = function Wrapper(props) {
        var newProps = _extends({}, props);

        var _iteratorNormalCompletion2 = true;
        var _didIteratorError2 = false;
        var _iteratorError2 = undefined;

        try {
            for (var _iterator2 = Object.entries(defaults)[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
                var _step2$value = _slicedToArray(_step2.value, 2),
                    _prop = _step2$value[0],
                    defaultValue = _step2$value[1];

                if (props[_prop] === null) {
                    newProps[_prop] = defaultValue;
                }
            }
        } catch (err) {
            _didIteratorError2 = true;
            _iteratorError2 = err;
        } finally {
            try {
                if (!_iteratorNormalCompletion2 && _iterator2.return) {
                    _iterator2.return();
                }
            } finally {
                if (_didIteratorError2) {
                    throw _iteratorError2;
                }
            }
        }

        return _react2.default.createElement(Component, newProps);
    };

    // Now do a little bit of housekeeping with the component name and set the passed in 'loose'
    // propTypes on the wrapping component.

    var componentName = Component.displayName || Component.name || 'Component';

    Wrapper.displayName = 'WithDefaults(' + componentName + ')';
    Wrapper.propTypes = propTypes;

    return Wrapper;
}

/**
 * @param {Component} Target - The component that defines `onOutsideEvent` handler.
 * @param {String[]} listeners - A list of valid DOM event names to listen for.
 *
 * @return {Component} The target wrapped in a HOC.
 */
function OutsideEventListener(Target) {
    var listeners = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];

    return function (_Component) {
        _inherits(OutsideEventListener, _Component);

        function OutsideEventListener() {
            var _ref;

            var _temp, _this, _ret;

            _classCallCheck(this, OutsideEventListener);

            for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
                args[_key] = arguments[_key];
            }

            return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = OutsideEventListener.__proto__ || Object.getPrototypeOf(OutsideEventListener)).call.apply(_ref, [this].concat(args))), _this), _this.target = null, _this.handleEvent = function (event) {
                if (_this.target) {
                    var targetElement = _reactDom2.default.findDOMNode(_this.target);
                    var isInside = targetElement === event.target || targetElement.contains(event.target);

                    if (!isInside) {
                        _this.target.onOutsideEvent(event);
                    }
                }
            }, _this.storeTarget = function (ref) {
                if (ref && !ref.onOutsideEvent) {
                    throw new Error('Component does not define "onOutsideEvent" method.');
                }

                _this.target = ref;
            }, _temp), _possibleConstructorReturn(_this, _ret);
        }

        _createClass(OutsideEventListener, [{
            key: 'componentDidMount',
            value: function componentDidMount() {
                var _iteratorNormalCompletion3 = true;
                var _didIteratorError3 = false;
                var _iteratorError3 = undefined;

                try {
                    for (var _iterator3 = listeners[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
                        var eventName = _step3.value;

                        window.addEventListener(eventName, this.handleEvent, false);
                    }
                } catch (err) {
                    _didIteratorError3 = true;
                    _iteratorError3 = err;
                } finally {
                    try {
                        if (!_iteratorNormalCompletion3 && _iterator3.return) {
                            _iterator3.return();
                        }
                    } finally {
                        if (_didIteratorError3) {
                            throw _iteratorError3;
                        }
                    }
                }
            }
        }, {
            key: 'componentWillUnmount',
            value: function componentWillUnmount() {
                var _iteratorNormalCompletion4 = true;
                var _didIteratorError4 = false;
                var _iteratorError4 = undefined;

                try {
                    for (var _iterator4 = listeners[Symbol.iterator](), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
                        var eventName = _step4.value;

                        window.removeEventListener(eventName, this.handleEvent, false);
                    }
                } catch (err) {
                    _didIteratorError4 = true;
                    _iteratorError4 = err;
                } finally {
                    try {
                        if (!_iteratorNormalCompletion4 && _iterator4.return) {
                            _iterator4.return();
                        }
                    } finally {
                        if (_didIteratorError4) {
                            throw _iteratorError4;
                        }
                    }
                }
            }
        }, {
            key: 'render',
            value: function render() {
                return _react2.default.createElement(Target, _extends({}, this.props, { ref: this.storeTarget }));
            }
        }]);

        return OutsideEventListener;
    }(_react.Component);
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/@cotidia/react-ui/lib/Utils/index.js
// module id = 21
// module chunks = 0